<template>
  <div class="full-wrapper pannel">
    <el-scrollbar :ref="scrollbarRef">
      <div class="full">
        <!-- <w-operation-state-info :params="params" :rsc-info="operationStateParams"></w-operation-state-info> -->
        <el-row>
          <div class="row">
            <el-col :md="12" :lg="12">
              <w-perf-widget :show-change-btn="false">
              <span slot="perfHeader">구성 정보</span>
              <div slot="perfBody">
                <el-col :md="24" :lg="12">
                  <table class="list-none-border">
                    <tr>
                      <th>인덱스</th>
                      <td>{{ configInfoData.netinterfaceIfindex }}</td>
                    </tr>
                    <tr>
                      <th>인터페이스 명</th>
                      <td>{{ configInfoData.netinterfaceName }}</td>
                    </tr>
                    <tr>
                      <th>Admin 상태</th>
                      <td>{{ configInfoData.netinterfaceStatusAdmin === 1 ? 'UP' : 'DOWN' }}</td>
                    </tr>
                    <tr>
                      <th>Oper 상태</th>
                      <td>{{ configInfoData.netinterfaceStatusOper === 1 ? 'UP' : 'DOWN' }}</td>
                    </tr>
                    <tr>
                      <th>별칭</th>
                      <td>{{ configInfoData.netinterfaceAlias ? configInfoData.netinterfaceAlias : '-' }}</td>
                    </tr>
                  </table>
                </el-col>
                <el-col :md="24" :lg="12">
                  <table class="list-none-border">
                    <tr>
                      <th>종류</th>
                      <td>{{ configInfoData.netinterfaceType ? configInfoData.netinterfaceType : '-' }}</td>
                    </tr>
                    <tr>
                      <th>대역폭</th>
                      <td>{{ configInfoData.netinterfaceSpeed ? configInfoData.netinterfaceSpeed : '-' }}</td>
                    </tr>
                    <tr>
                      <th>Duplex</th>
                      <td>{{ configInfoData.netinterfaceDuplex ? configInfoData.netinterfaceDuplex : '-' }}</td>
                    </tr>
                    <tr>
                      <th>인터페이스 IP</th>
                      <td>{{ configInfoData.ipaddress ? configInfoData.ipaddress : '-' }}</td>
                    </tr>
                    <tr>
                      <th>MAC 주소</th>
                      <td>{{ configInfoData.netinterfaceMacaddress ? configInfoData.netinterfaceMacaddress : '-' }}</td>
                    </tr>
                    <tr>
                      <th>관리자 (정/부)</th>
                      <td>{{ configInfoData.majorLabel }}</td>
                    </tr>
                    <tr>
                      <th></th>
                      <td>{{ configInfoData.minorLabel }}</td>
                    </tr>
                  </table>
                </el-col>
              </div>
              <div slot="perfFooter">
                <span>최근 변경시각: {{ configInfoData.checkDatetimeLabel }} </span>
              </div>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-event-info-widget :event-info-data="eventInfoData"></w-event-info-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('BPS', ...arguments)" :show-change-btn="false" :eventlevel="bpsData.eventlevel">
              <span slot="perfHeader">BPS</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="bpsViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in bpsData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="bpsData.backBody"></w-summary-line-chart>
              <!-- FOOTER -->
              <ul class="multi" v-if="bpsViewIndex === 0" slot="perfFooter">
                <w-perf-footer-h-info v-for="data in bpsData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in bpsData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(bpsData.backBody, data) }" />
              </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('PPS', ...arguments)" :show-change-btn="false" :eventlevel="ppsData.eventlevel">
              <span slot="perfHeader">PPS</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="ppsViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in ppsData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="ppsData.backBody"></w-summary-line-chart>
              <!-- FOOTER -->
              <ul class="multi" v-if="ppsViewIndex === 0" slot="perfFooter">
                <w-perf-footer-h-info v-for="data in ppsData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in ppsData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(ppsData.backBody, data) }" />
              </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('USERATE', ...arguments)" :show-change-btn="false" :eventlevel="userateData.eventlevel">
              <span slot="perfHeader">이용률</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="userateViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in userateData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="userateData.backBody"></w-summary-line-chart>
              <!-- FOOTER -->
              <ul class="multi" v-if="userateViewIndex === 0" slot="perfFooter">
                <w-perf-footer-h-info v-for="data in userateData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in userateData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(userateData.backBody, data) }" />
              </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('ERROR', ...arguments)" :show-change-btn="false" :eventlevel="errorData.eventlevel">
              <span slot="perfHeader">에러율</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="errorViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in errorData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="errorData.backBody"></w-summary-line-chart>
              <!-- FOOTER -->
              <ul class="multi" v-if="errorViewIndex === 0" slot="perfFooter">
                <w-perf-footer-h-info v-for="data in errorData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in errorData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(errorData.backBody, data) }" />
              </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('DISCARD', ...arguments)" :show-change-btn="false" :eventlevel="discardData.eventlevel">
              <span slot="perfHeader">기각률</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="discardViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in discardData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="discardData.backBody"></w-summary-line-chart>
              <!-- FOOTER -->
              <ul class="multi" v-if="discardViewIndex === 0" slot="perfFooter">
                <w-perf-footer-h-info v-for="data in discardData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in discardData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(discardData.backBody, data) }" />
              </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('CRC', ...arguments)" :show-change-btn="false" :eventlevel="crcData.eventlevel">
              <span slot="perfHeader">CRC/Collision</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="crcViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in crcData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="crcData.backBody"></w-summary-line-chart>
              <!-- FOOTER -->
              <ul class="multi" v-if="crcViewIndex === 0" slot="perfFooter">
                <w-perf-footer-h-info v-for="data in crcData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in crcData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(crcData.backBody, data) }" />
              </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('PPSB', ...arguments)" :show-change-btn="false" :eventlevel="ppsbData.eventlevel">
              <span slot="perfHeader">Broadcast PPS</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="ppsbViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in ppsbData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="ppsbData.backBody"></w-summary-line-chart>
              <!-- FOOTER -->
              <ul class="multi" v-if="ppsbViewIndex === 0" slot="perfFooter">
                <w-perf-footer-h-info v-for="data in ppsbData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in ppsbData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(ppsbData.backBody, data) }" />
              </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('PPSM', ...arguments)" :show-change-btn="false" :eventlevel="ppsmData.eventlevel">
              <span slot="perfHeader">Multicast PPS</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="ppsmViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in ppsmData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="ppsmData.backBody"></w-summary-line-chart>
              <!-- FOOTER -->
              <ul class="multi" v-if="ppsmViewIndex === 0" slot="perfFooter">
                <w-perf-footer-h-info v-for="data in ppsmData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in ppsmData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(ppsmData.backBody, data) }" />
              </ul>
              </w-perf-widget>
            </el-col>
          </div>
        </el-row>
      </div>
    </el-scrollbar>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
  </div>
</template>

<script>
import clone from 'lodash/clone';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import moment from 'moment';
import { mapGetters } from 'vuex';
import ScrollbarMixin from '@/mixins/scrollbar';
import { EMPTY_TEXT } from '@/utils/string';
import { convertValueForInterfaceSpeed } from '@/utils/number';
import { NETINTERFACE } from '@/constants/summary';
import summaryApi from '@/api/performance/summary/summary-info';
import netinterfaceApi from '@/api/performance/netinterface/netinterface-info';
import { getIntervalDatetimeParams } from '@/utils/date';
import WPerfWidget from '../components/PerfWidget';
import WPerfBodyInfo from '../components/PerfBodyInfo';
import WPerfFooterVInfo from '../components/PerfFooterVInfo';
import WPerfFooterHInfo from '../components/PerfFooterHInfo';
import WOperationStateInfo from '../components/OperationStateInfo';
import WSummaryLineChart from '../components/SummaryLineChart';
import WEventInfoWidget from '../components/EventInfoWidget';

export default {
  name: 'WPerformanceNetinterfaceSummary',
  mixins: [ScrollbarMixin],
  components: {
    WPerfWidget,
    WPerfBodyInfo,
    WPerfFooterVInfo,
    WPerfFooterHInfo,
    WOperationStateInfo,
    WSummaryLineChart,
    WEventInfoWidget,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      params: {
        managetypeId: 'NMS',
        managetypeKey: 'NI',
      },
      operationStateParams: { rsctypeId: '', rscId: '', rscKey: '_' },
      configInfoData: {},
      operationStateData: {},
      eventInfoData: {},
      bpsViewIndex: 1,
      ppsViewIndex: 1,
      userateViewIndex: 1,
      errorViewIndex: 1,
      discardViewIndex: 1,
      crcViewIndex: 1,
      ppsbViewIndex: 1,
      ppsmViewIndex: 1,
      bpsData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      ppsData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      userateData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      errorData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      discardData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      crcData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      ppsbData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      ppsmData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler(node) {
        if (isEmpty(node)) {
          return;
        }
        this.loadData();
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadData();
      },
    },
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    getIntervalDatetimeParams,
    loadData() {
      if (this.active) {
        const startDatetime = this.getIntervalDatetimeParams(new Date(), 'hour', 12);
        Object.assign(this.params, {
          objId: this.selectedNode.obj.objId,
          startDatetime,
        });
        this.loadConfInfoView();
        this.loadEventInfo();

        const widgetKeyList = ['BPS', 'PPS', 'USERATE', 'ERROR', 'DISCARD', 'CRC', 'PPSB', 'PPSM'];
        widgetKeyList.forEach((widgetKey) => {
          const widgetKeyLower = widgetKey.toLowerCase();
          this.changeWidgetView(widgetKey, this[`${widgetKeyLower}ViewIndex`]);
        });
      }
    },
    /**
     * 구성 정보 load
     * @author jeee12
     */
    loadConfInfoView() {
      netinterfaceApi.getNetinterfaceConfigurationInfo({
        objId: this.selectedNode.obj.objId,
      }).then((response) => {
        if (response.data.success) {
          const configInfo = response.data.data;
          let majorLabel = EMPTY_TEXT;
          let minorLabel = EMPTY_TEXT;

          if (configInfo.majorName) {
            majorLabel = configInfo.majorDepartment ? `[${configInfo.majorDepartment}]${configInfo.majorName}` : `[${EMPTY_TEXT}]${configInfo.majorName}`;
          }
          if (configInfo.minorName) {
            minorLabel = configInfo.minorDepartment ? `[${configInfo.minorDepartment}]${configInfo.minorName}` : `[${EMPTY_TEXT}]${configInfo.minorName}`;
          }
          configInfo.majorLabel = majorLabel;
          configInfo.minorLabel = minorLabel;
          configInfo.netinterfaceSpeed = convertValueForInterfaceSpeed(configInfo.netinterfaceSpeed) || EMPTY_TEXT;
          configInfo.checkDatetimeLabel = !isNil(configInfo.checkDatetime) ? moment(configInfo.checkDatetime).format('YYYY년 MM월 DD일 HH:mm:ss') : EMPTY_TEXT;
          this.configInfoData = configInfo;
        }
      });
    },
    /**
     * 이벤트 정보 조회
     * @author kimjy
     */
    loadEventInfo() {
      const params = clone(this.params);
      params.endDatetime = new Date().getTime();

      summaryApi.getSummaryEventInfo(params).then((response) => {
        if (response.data.success) {
          this.eventInfoData = response.data.data;
        }
      });
    },
    /**
     * 위젯 전면 또는 후면 데이터 로드
     * @author jeee12
     * @param  {String} widgetKey 위젯 key (rsctypeId)
     * @param  {Integer} viewIndex 위젯 viewIndex
     */
    changeWidgetView(widgetKey, viewIndex) {
      const widgetKeyLower = widgetKey.toLowerCase();
      this[`${widgetKeyLower}ViewIndex`] = viewIndex;
      // 데이터 로드
      if (this[`${widgetKeyLower}ViewIndex`] === 0) {
        // 전면 데이터 로드 함수 호출
        this.loadFrontData(widgetKey);
      } else {
        // 후면 데이터 로드 함수 호출
        this.loadBackData(widgetKey);
      }
    },
    /**
     * 전면 데이터 로드 함수
     * @author kimjy
     * @param  {String} widgetType 로드할 위젯 종류
     */
    loadFrontData(widgetKey) {
      const widgetParam = clone(this.params);
      Object.assign(widgetParam, {
        summaryWidgetKey: widgetKey,
        rscInfoList: NETINTERFACE.FRONT[widgetKey],
        rscKey: '_', // 현재 rslt를 조회하는 위젯은 '_'를 Key로 사용함
      });

      netinterfaceApi.getInterfaceSummaryRscRsltList(widgetParam).then((response) => {
        if (response.data.success) {
          this[widgetKey.toLowerCase().concat('Data')].frontBody = response.data.data.body;
          this[widgetKey.toLowerCase().concat('Data')].frontFooter = response.data.data.footer;
        }
      });
    },
    /**
     * 후면 데이터 로드 함수
     * @author kimjy
     * @param  {String} widgetType 로드할 위젯 종류
     */
    loadBackData(widgetKey) {
      const widgetParam = clone(this.params);
      Object.assign(widgetParam, {
        summaryWidgetKey: widgetKey,
        rscInfoList: NETINTERFACE.BACK[widgetKey],
        rscKey: '_', // 현재 rslt를 조회하는 위젯은 '_'를 Key로 사용함
      });
      netinterfaceApi.getInterfaceSummaryRscRsltBackList(widgetParam).then((response) => {
        if (response.data.success) {
          this[widgetKey.toLowerCase().concat('Data')].backBody = response.data.data.body;
          this[widgetKey.toLowerCase().concat('Data')].backFooter = response.data.data.footer;
          this[widgetKey.toLowerCase().concat('Data')].eventlevel = response.data.data.eventlevel;
        }
      });
    },
    /**
     * 후면 body 데이터 중 footer 데이터의 인덱스 검색
     * @author jeee12
     * @param  {[type]} backBodySeries [description]
     * @param  {[type]} footer         [description]
     * @return {[type]}                [description]
     */
    findFooterIndex(backBodySeries, footer) {
      return backBodySeries.findIndex((e) => {
        if (footer.rsckey) {
          return e.rscInfo.rscKeyName === footer.rscKeyName;
        } else if (e.rscInfo) {
          return e.rscInfo.rsctypeId === footer.rsctypeId && e.rscInfo.rscId === footer.rscId;
        }
        return null;
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/netinterface/index.vue